"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AttributeComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _unitPrice = _interopRequireDefault(require("./../util/unitPrice"));
var _InputComponent = _interopRequireDefault(require("./InputComponent"));
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _storeProvider = require("./../util/storeProvider");
var _uxcore = require("@ux/uxcore2");
var _Button = require("./Button.styles");
var _common = require("./../util/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AttributeComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visibleEnums: this.props.initialVisibleEnums,
      showDisclaimer: this.showDisclaimer()
    };
    this.handleShowMore = this.handleShowMore.bind(this);
  }
  handleShowMore() {
    this.setState({
      visibleEnums: this.props.enum.length
    });
  }
  showDisclaimer() {
    const hasDisclaimerText = this.props.content.shared && this.props.content.shared['disclaimer-text'];
    return hasDisclaimerText;
  }
  render() {
    const {
      type,
      enum: enums = [],
      instancePath = '',
      layoutProperties = {},
      content = {},
      groupContent = {},
      content: {
        shared: contentShared = {}
      },
      selectedVal,
      maxPricePerMonthFormatted,
      minPricePerMonthFormatted,
      propertytype
    } = this.props;
    const title = {
      __html: contentShared.title
    } || {};
    const description = {
      __html: contentShared.description
    } || {};
    const {
      visibleEnums,
      showDisclaimer
    } = this.state;
    const {
      termType
    } = this.context.store.getTermDataByPackageId(instancePath.split('.')[0]);
    /*
      selectedValOffset is used when visibleEnum is less than enum.length
      to reduce visibleEnum value by 1 if the selected value is not yet visible
      in order to always show the selected enum and respect visibleEnum shown
    */
    let selectedValOffset = 1;
    return /*#__PURE__*/React.createElement(_react.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "pb-2 mb-2"
    }, title.__html && /*#__PURE__*/React.createElement("h3", {
      dangerouslySetInnerHTML: title
    }), description.__html && /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: description
    }), /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    },
    //  enums returning true continue to map function
    enums.filter(enumVal =>
    // enum does not contain content
    typeof content[enumVal] === 'object' &&
    // checkboxes toggle betweem checked/unchecked
    // checkbox 'none' does not need to be rendered
    !(layoutProperties.display === 'checkbox' && enumVal === 'none') && !(layoutProperties.display === 'domainSearch' && enumVal === 'none')).map((enumVal, i) => {
      if (i >= visibleEnums - selectedValOffset && enumVal !== selectedVal) return null;
      // selected value is visible and offset is no longer needed
      if (enumVal === selectedVal) {
        selectedValOffset = 0;
      }
      return /*#__PURE__*/React.createElement(_InputComponent.default, {
        includeState: [{
          path: 'app.postComplete'
        }],
        type: type,
        enumVal: enumVal,
        selectedVal: selectedVal,
        instancePath: instancePath,
        layoutProperties: layoutProperties,
        groupContent: groupContent,
        content: content[enumVal],
        price: (0, _unitPrice.default)(this.props, enumVal, i),
        key: (0, _common.getInstancePathKey)(`${instancePath}.${enumVal}`, propertytype),
        quantifier: contentShared.quantifier,
        termType: termType
      });
    }), layoutProperties.display === 'priceOverride' && /*#__PURE__*/React.createElement(_InputComponent.default, {
      includeState: [{
        path: 'app.postComplete'
      }],
      selectedVal: selectedVal,
      instancePath: instancePath,
      layoutProperties: layoutProperties,
      content: contentShared,
      maxPricePerMonthFormatted: maxPricePerMonthFormatted,
      minPricePerMonthFormatted: minPricePerMonthFormatted
    })), visibleEnums < enums.length && /*#__PURE__*/React.createElement(_Button.IconBelowTextButton, {
      className: "show-more"
    }, /*#__PURE__*/React.createElement(_uxcore.Button, {
      design: "inline",
      onClick: this.handleShowMore,
      tabIndex: 0,
      text: content.shared['show-more-label'],
      icon: /*#__PURE__*/React.createElement(_chevronDown.default, {
        width: 16,
        height: 16
      })
    })), showDisclaimer && /*#__PURE__*/React.createElement("div", {
      className: "row mr-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-12 att-disclaimer"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
      className: "text-black"
    }, content.shared['disclaimer-text']))))));
  }
}
exports.AttributeComponent = AttributeComponent;
AttributeComponent.propTypes = {
  initialVisibleEnums: _propTypes.default.number,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  type: _propTypes.default.string,
  enum: _propTypes.default.array,
  name: _propTypes.default.string,
  propertytype: _propTypes.default.string,
  instancePath: _propTypes.default.string,
  layoutProperties: _propTypes.default.shape({
    display: _propTypes.default.string.required,
    modal: _propTypes.default.array,
    disclaimer: _propTypes.default.array
  }),
  groupContent: _propTypes.default.object,
  content: _propTypes.default.object,
  pkgqty: _propTypes.default.number,
  maxPricePerMonthFormatted: _propTypes.default.string,
  minPricePerMonthFormatted: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(AttributeComponent);